import axios from 'axios';
import { ulid } from 'ulid';


let url = new URL(document.baseURI)
url.hash = ''
url.pathname += 'api'
export const api_url = url.toString()


export const api = axios.create({
    baseURL: api_url
    //baseURL: `http://localhost:39219/api`,
    //baseURL: 'https://app.auditaestoque.com.br/api'
});



api.interceptors.request.use(config => {
    /*
    if (localStorage.getItem('access_token')) {
        let access_token = localStorage.getItem('access_token');
        if (!config.params) {
            config.params = {};
        }
        config.params.access_token = access_token;
    }
    */
    let params = {
        ...config.params,
        request_id: ulid()
    }
    return {
        ...config,
        params
    };
}, err => {
    
    return Promise.reject(err);
})




export default api;